import { render, staticRenderFns } from "./simple-upload-demo.vue?vue&type=template&id=3f52a436&scoped=true"
import script from "./simple-upload-demo.vue?vue&type=script&lang=js"
export * from "./simple-upload-demo.vue?vue&type=script&lang=js"
import style0 from "./simple-upload-demo.vue?vue&type=style&index=0&id=3f52a436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52a436",
  null
  
)

export default component.exports